import { Component, OnInit, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { Observable, Subscription } from 'rxjs';
import { User } from '../../../models/user.interface';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarService } from '../../../core/services/sidebar.service';
import { filter, map } from 'rxjs/operators';
import { LogoComponent } from '../logo/logo.component';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, LogoComponent],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  private routerSub!: Subscription;
  currentUser$: Observable<User | null>;
  unreadCount$!: Observable<number>;

  constructor(
    private authService: AuthService,
    private router: Router,
    private sidebarService: SidebarService,
    private elementRef: ElementRef,
    private notificationService: NotificationService
  ) {
    this.currentUser$ = this.authService.currentUser$;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Only run this logic on mobile view
    if (window.innerWidth > 768) {
      return;
    }

    // Check if the click is outside the sidebar and the sidebar is open
    if (!this.elementRef.nativeElement.contains(event.target) && this.sidebarService.isOpen()) {
      // Also check that the click was not on the toggle button
      const target = event.target as HTMLElement;
      if (!target.closest('.sidebar-toggle-button')) { // Assuming the toggle has this class
        this.sidebarService.close();
      }
    }
  }

  ngOnInit(): void {
    this.unreadCount$ = this.notificationService.getNotifications().pipe(
      map(notifications => notifications.filter(n => !n.isRead).length)
    );

    // Cierra automáticamente el sidebar en móviles después de navegar
      this.routerSub = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
       ).subscribe(() => {
        if (window.innerWidth <= 768) {
           this.sidebarService.close();
        }
     });
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
